import styled from 'styled-components';
import { fontSize } from '../utils/style/font';
import space from '../utils/style/space';
import color from '../utils/style/color';

interface Props {
  disabled: boolean;
}

/**
 * font-sizeは元々13px指定だが、mobile safariでは16pxより小さいサイズだと
 * フォーカスが当たった時に画面が拡大されてしまうため、16pxにしてある。
 *
 * See. https://qiita.com/skwbr/items/b285cc312587c73a4812
 */

const Input = styled.input<Props>`
  height: 38px;
  font-size: ${fontSize.l}px;
  color: #000;
  border-radius: 2px;
  background-color: ${({ disabled }) =>
    disabled ? color.gray.xxxBright : color.gray.xxxxBright};
  padding-left: ${space.xxs}px;
  padding-right: ${space.xxs}px;
  box-shadow: 0 0 2px 0 rgba(221, 221, 221, 0.5);
  border: solid 1px #e3e3e3;
  -webkit-appearance: none;
  &:focus {
    outline: none;
    border: solid 1px rgba(233, 30, 99, 0.3);
  }
  &::placeholder {
    color: ${color.gray.xxBright};
  }
`;

export default Input;
